/**
 * <TutorStudentRowSkeleton> — la forme d'une ligne de « Mes élèves » pendant le chargement.
 *
 * L'avatar, le nom et la classe, puis une matière et sa séance : la géométrie de `<TutorStudentRow>`,
 * importée et non recopiée.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { SubjectBadgeSkeleton } from "../../atoms/SubjectBadge/SubjectBadgeSkeleton"
import { CardListRow } from "../../molecules/CardList"
import { TUTOR_STUDENT_AVATAR_SIZE } from "./TutorStudentRow"

export function TutorStudentRowSkeleton() {
    return (
        <CardListRow>
            <Row gap="3" align="center">
                <Skeleton shape="circle" size={TUTOR_STUDENT_AVATAR_SIZE} />
                <Stack gap="1" style={styles.body}>
                    <Skeleton textSize="text-md" width={130} />
                    <Row gap="2" align="center">
                        <SubjectBadgeSkeleton />
                        <Skeleton textSize="text-sm" width={70} />
                    </Row>
                </Stack>
            </Row>
        </CardListRow>
    )
}

const styles = StyleSheet.create(() => ({
    body: { flex: 1, flexShrink: 1 },
}))
